import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import { Fab } from '@material-ui/core';
var Button = styled(Fab)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 25px;\n  right: 25px;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return "\n    z-index: ".concat(theme.zIndex.backToTop, ";\n  ");
});
Button.displayName = 'BackToTop-Button';
export default Button;